import zendesk from '../assets/icons/zendesk.svg';
import twitter from '../assets/icons/twitter.svg';
import youtube from '../assets/icons/youtube.svg';
import linkedin from '../assets/icons/linkedin.svg';
import facebook from '../assets/icons/facebook.svg';
import appStore from '../assets/icons/app_store.svg';
import freshdesk from '../assets/icons/freshdesk.svg';
import pinterest from '../assets/icons/pinterest.svg';
import instagram from '../assets/icons/instagram.svg';
import playStore from '../assets/icons/google_play.svg';

export default {
  appStore: ({ link }) => ({
    image: appStore,
    title: 'App Store',
    link,
  }),
  zendesk: ({ link }) => ({
    image: zendesk,
    title: 'Zendesk',
    link,
  }),
  twitter: ({ link }) => ({
    image: twitter,
    title: 'Twitter',
    link,
  }),
  facebook: ({ link }) => ({
    image: facebook,
    title: 'Facebook',
    link,
  }),
  pinterest: ({ link }) => ({
    image: pinterest,
    title: 'Pinterest',
    link,
  }),
  instagram: ({ link }) => ({
    image: instagram,
    title: 'Instagram',
    link,
  }),
  playStore: ({ link }) => ({
    image: playStore,
    title: 'Play Store',
    link,
  }),
  freshdesk: ({ link }) => ({
    image: freshdesk,
    title: 'Freshdesk',
    link,
  }),
  youtube: ({ link }) => ({
    image: youtube,
    title: 'Youtube',
    link,
  }),
  linkedin: ({ link }) => ({
    image: linkedin,
    title: 'Linkedin',
    link,
  }),
};
